import Component from '../core/Component'
import Scroll from '../services/Scroll'
import EventBus from '../core/EventBus'
import {EVENTS} from '../core/Events'

export default class FixedHeader extends Component {
    constructor(element, options) {
        super(element, options)

        this.darkSectionsQuery = ['.Bg','.Footer','.SectionCard--bgBlue','.Header']
        this.sizes = {}
    }

    prepare() {
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)
        EventBus.on(EVENTS.BG_TRANSITIONEND, this.handleBgTransitionEnd)

        this.resize()
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
        EventBus.off(EVENTS.BG_TRANSITIONEND, this.handleBgTransitionEnd)
    }

    handleBgTransitionEnd = () => {
        this.resize()
    }

    handleScroll = () => {
        this.update()
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        const els = [...document.querySelectorAll(this.darkSectionsQuery)]
        const scrollY = Scroll.getScroll().y
        const sections = els.map(el => {
            const rect = el.getBoundingClientRect()
            
            return {
                documentTop: scrollY + rect.top,
                documentBottom: scrollY + rect.top + rect.height
            }
        })

        this.sizes = {
            sections 
        }

        this.update()
    }

    update() {
        if (!this.sizes) {
            this.resize()
            return
        }

        const scrollY = Scroll.getScroll().y + 75
        
        const isOnDark = !!this.sizes.sections.find(section => scrollY >= section.documentTop && scrollY <= section.documentBottom)

        this.element.classList.toggle('is-ondark',isOnDark)
    }
}